import { ChangeContactFieldNodeData } from 'modules/workflows/types';
import styled from 'styled-components';
import { StyledLeftTooltip } from 'modules/workflowNodeEditors/EditorBody.styled';
import { InputText } from 'ui/inputs';
import { Label, spacing } from 'ui/theme';
import { isValidUrlWithHandlebars } from 'utils/validation';

export const StyledFormLabel = styled(Label)`
  margin-bottom: ${spacing.half};
`;

const FormFieldWrapper = styled.div`
  margin-bottom: ${spacing.base};
`;

export const INPUT_TEST_ID = 'input-endpoint-url';
export const INPUT_TOKEN_TEST_ID = 'input-authtoken-url';

type UpdateViaWebhookProps = {
  values: Pick<ChangeContactFieldNodeData, 'endpoint' | 'authToken'>;
  setEndpoint: (data: string) => void;
  setAuthToken: (data: string) => void;
  isReadOnly: boolean;
  cloneErrors: Record<string, boolean>;
  cloneDisplayValues: Record<string, any>;
};

export const UpdateViaWebhook = ({
  values,
  setEndpoint,
  setAuthToken,
  isReadOnly,
  cloneErrors = {},
  cloneDisplayValues = {},
}: UpdateViaWebhookProps) => {
  const { endpoint = '', authToken = '' } = values;
  const { endpoint: endpointError, authToken: authTokenError } = cloneErrors;
  return (
    <>
      <FormFieldWrapper>
        <StyledFormLabel>Endpoint URL</StyledFormLabel>
        <StyledLeftTooltip isEnabled={isReadOnly} tooltipContent={endpoint}>
          <InputText
            id={INPUT_TEST_ID}
            data-test={INPUT_TEST_ID}
            onChange={setEndpoint}
            type="text"
            value={endpoint}
            placeholder={endpointError ? cloneDisplayValues.endpoint : 'https://www.example.com'}
            hasError={endpointError || isValidUrlWithHandlebars(endpoint).length > 0}
            isDisabled={isReadOnly}
          />
        </StyledLeftTooltip>
      </FormFieldWrapper>
      <FormFieldWrapper>
        <StyledFormLabel>Authorization token</StyledFormLabel>
        <StyledLeftTooltip isEnabled={isReadOnly} tooltipContent={authToken}>
          <InputText
            id="input-authorization-token"
            data-test={INPUT_TOKEN_TEST_ID}
            onChange={setAuthToken}
            type="text"
            value={authToken}
            placeholder={authTokenError ? cloneDisplayValues.authToken : ''}
            hasError={authTokenError}
            isDisabled={isReadOnly}
          />
        </StyledLeftTooltip>
      </FormFieldWrapper>
    </>
  );
};
